export class Location {
    id: number;
    city: string;
    state: string;
    postalCode: string;
    country?: string;

    constructor(id: number, city: string, state: string, postalCode: string, country?: string) {
        this.id = id;
        this.city = city;
        this.state = state;
        this.postalCode = postalCode;
        this.country = country;
    }

    get description(): string {
        if (this.city === '' && this.state === '' && this.postalCode === '')
            return '';

        return `${this.city}, ${this.state} ${this.postalCode}`;
    }

    equals(other: Location): boolean {
        return !!other && this.city === other.city && this.state === other.state && this.postalCode === other.postalCode;
    }

    toString(): string {
        return this.description;
    }
}
